export default {
    entity: 'Term sheet',
    name: 'Name',
    termsheetType: 'Termsheet Type',
    createdAt: 'Created At',
    updatedAt: 'Last Updated',
    noData: 'No term sheets',
};
